import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';


function FormBuilderModal({isOpen, closeModal, modalMessage}) {

  const customStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgb(0 0 0 / 80%)',
      zIndex:100,
      width:'700x',
      height:'500x',
    },
    content: {
      position: 'relative',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'500px',
      height:'500',
      overflow: 'hidden'
     
    },
    closeBtn:{
      position: 'absolute',
      top:0,
      right:'-1%',
      background:'transparent',
      border:'none',
      color:'red'
    }
  
    
  };



  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      contentLabel="Form Builder"
    >
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="message text-center">
              <h4 className="text-secondary text-transform-uppercase mb-4 border-bottom pb-2">{modalMessage ? modalMessage.title : `Warning`}!</h4>
              <p className="mb-4">{modalMessage ? modalMessage.message : `You have to save the form if you want to processed to next`}.</p>
              <button className="btn btn-secondary" type="button" onClick={()=>{closeModal(false)}}>Close</button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default FormBuilderModal
